// utils
import PadEditorPrescriptionDiet from '../components-js/pad-prescription/PadPrescriptionDiet';

const TEMPLATE_NAME = 'PAD_EDITOR_PRESCRIPTION_DIET';

const initialState = {
  errors: [],
  data: {
    current: [],
    loaded: [],
    screen: []
  }
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case `${TEMPLATE_NAME}_PENDING`: {
      const padEditorPrescription = new PadEditorPrescriptionDiet(state);

      return padEditorPrescription.setLoading().setErrors().getState();
    }

    case `${TEMPLATE_NAME}_FULFILLED`: {
      const { currentPadPrescriptionDiet, previousPadPrescriptionDiet } = action.payload;

      const padEditorPrescription = new PadEditorPrescriptionDiet(state);

      return padEditorPrescription
        .prepare(currentPadPrescriptionDiet, previousPadPrescriptionDiet)
        .setLoading(false)
        .getState();
    }

    case `${TEMPLATE_NAME}_REJECTED`: {
      const errors = action.payload.errors;

      const padEditorPrescription = new PadEditorPrescriptionDiet(state);

      return padEditorPrescription.setErrors(errors).setLoading(false).getState();
    }

    case `${TEMPLATE_NAME}_ADD`: {
      const prescriptionForm = action.payload.data;
      const padEditorPrescription = new PadEditorPrescriptionDiet(state);

      // prettier-ignore
      return padEditorPrescription
        .add(prescriptionForm)
        .replacesAllPrescriptors(prescriptionForm)
        .getState();
    }

    case `${TEMPLATE_NAME}_EDIT`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padEditorPrescription = new PadEditorPrescriptionDiet(state);

      return padEditorPrescription
        .edit(code, prescriptionForm)
        .replacesAllPrescriptors(prescriptionForm)
        .getState();
    }

    case `${TEMPLATE_NAME}_REMOVE`: {
      const prescription = action.payload.data;
      const { code } = prescription;
      const padEditorPrescription = new PadEditorPrescriptionDiet(state);

      return padEditorPrescription.remove(code).getState();
    }

    case `${TEMPLATE_NAME}_SUSPEND`: {
      const prescription = action.payload.data;
      const { code } = prescription;
      const padEditorPrescription = new PadEditorPrescriptionDiet(state);

      // prettier-ignore
      return padEditorPrescription
        .suspend(code)
        .getState();
    }

    case `${TEMPLATE_NAME}_UNSUSPEND`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padEditorPrescription = new PadEditorPrescriptionDiet(state);

      // prettier-ignore
      return padEditorPrescription
        .unsuspend(code, prescriptionForm)
        .getState();
    }

    case `${TEMPLATE_NAME}_CHANGE_STATUS`: {
      const prescriptionForm = action.payload.data;
      const { code } = prescriptionForm;
      const padCreatorPrescription = new PadEditorPrescriptionDiet(state);

      // prettier-ignore
      return padCreatorPrescription
        .changeStatus(code)
        .getState();
    }

    case `${TEMPLATE_NAME}_RESET`: {
      return initialState;
    }

    default: {
      return state;
    }
  }
};

export default reducer;
